export default class FloatingButton {
    constructor($button) {
        this.$button = $button;
        this.$parent = $button.parentNode;

        this.checkHide = this.checkHide.bind(this);

        window.addEventListener('scroll', this.checkHide);
    }

    checkHide() {
        if ((this.$parent.getBoundingClientRect().top - window.innerHeight) <= 0) {
            this.$button.classList.add('button--floating-hidden');
        } else {
            this.$button.classList.remove('button--floating-hidden');
        }
    }
}